import { useState } from 'react';
import { useSearchParams } from 'react-router';
import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/cn';
import { LabourPoliciesTab } from './LabourPoliciesTab';
import { VehiclesTab } from './VehiclesTab';

const TABS = [
  { key: 'shop-rates', labelKey: 'tabs.shopRates' },
  { key: 'vehicles', labelKey: 'tabs.vehicles' },
] as const;
type TabKey = (typeof TABS)[number]['key'];

export function PricingPageV2({ workspaceId }: { workspaceId: string | null }) {
  const { t } = useTranslation('pricingV2');
  const [searchParams] = useSearchParams();
  const tabParam = searchParams.get('tab');
  const initialTab = (TABS.find((t) => t.key === tabParam)?.key ?? 'shop-rates') as TabKey;
  const [tab, setTab] = useState<TabKey>(initialTab);

  return (
    <div className="flex flex-col gap-4 p-6 md:flex-row md:gap-5">
      <nav className="-mx-6 flex gap-0.5 overflow-x-auto px-6 md:mx-0 md:w-52 md:flex-none md:flex-col md:px-0" data-tour="page-pricing-tabs">
        {TABS.map((tb) => (
          <button
            key={tb.key}
            onClick={() => setTab(tb.key)}
            className={cn(
              'min-h-safe-tap flex-none whitespace-nowrap px-3 py-2 text-left text-sm font-medium md:min-h-0',
              tab === tb.key ? 'bg-ink text-surface' : 'text-muted hover:bg-surface-2',
            )}
          >
            {t(tb.key === 'shop-rates' ? 'tabs.labourPolicies' : tb.labelKey)}
          </button>
        ))}
      </nav>

      <div className={cn('flex-1', tab === 'vehicles' ? 'max-w-4xl' : 'max-w-2xl')}>
        {tab === 'shop-rates' ? <LabourPoliciesTab workspaceId={workspaceId} /> : null}
        {tab === 'vehicles' ? <VehiclesTab workspaceId={workspaceId} /> : null}
      </div>
    </div>
  );
}
